/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tag_InvestorInputs */

const cs_tag_investor = /** @type {(inputs: Tag_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor`)
};

const en_tag_investor = /** @type {(inputs: Tag_InvestorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Investor`)
};

/**
* | output |
* | --- |
* | "Investor" |
*
* @param {Tag_InvestorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tag_investor = /** @type {((inputs?: Tag_InvestorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tag_InvestorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tag_investor(inputs)
	return cs_tag_investor(inputs)
});